import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./auth/auth.slice";
import { networkReducer } from "./network/network.slice";
import { accountReducer } from "./account/account.slice";
import { contractReducer } from "./smart-contract/smart-contract.slice";

const rootReducer = combineReducers({
  auth: authReducer,
  network: networkReducer,
  // alert: alertReducer,
  account: accountReducer,
  contract: contractReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
